import {
  CLEAR_PROPS_DATA_SUCCESS,
  CREATE_TPWOU_SUCCESS,
  FETCH_QUOTATION_SUCCESS,
  FIND_TPW_SNO_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  resource: {},
  tpwSno : '',
  quotations: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_TPWOU_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case CLEAR_PROPS_DATA_SUCCESS: {
      return {
        ...state,
        resource: {},
        tpwSno : '',
        quotations: [],
      }
    }

    case FETCH_QUOTATION_SUCCESS: {
      return {
        ...state,
        quotations: action.data,
        total: action.count,
      }
    }

    case FIND_TPW_SNO_SUCCESS: {
      return {
        ...state,
        tpwSno: action.data,
      }
    }
    default:
      return state;
  }
}
